import { render } from "./LeadStatus.vue?vue&type=template&id=32c78de4"
import script from "./LeadStatus.vue?vue&type=script&lang=js"
export * from "./LeadStatus.vue?vue&type=script&lang=js"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__